// eslint-disable-next-line @typescript-eslint/no-unused-vars, unused-imports/no-unused-imports-ts
import { Build, Component, Element, Host, Prop, State, h } from '@stencil/core';

import { LazyLoadClassName, createSrcSet } from '../../utils';
import { registerElToObserverList } from '../../utils/observer';

@Component({
    tag: 'lazy-load-logo',
    styles: 'lazy-load-logo.css',
    shadow: false,
})
export class LazyLoadLogo {
    @Element() el: HTMLElement;

    @Prop() logo: string;
    @Prop() logoColor: string;
    @Prop() promoId: any;
    @Prop() width = 35;
    @Prop() height = 35;

    @State() isViewed = false;

    onView() {
        this.isViewed = true;
    }

    connectedCallback() {
        if (!Build.isTesting && !Build.isServer) {
            registerElToObserverList(this.el, this.onView.bind(this));
        } else {
            this.onView();
        }
    }

    render() {
        return (
            <Host>
                <picture>
                    <source srcSet={this.isViewed ? createSrcSet(this.logo, 450, 450) : undefined} type="image/webp" />
                    <img
                        class={`lazy-logo ${LazyLoadClassName.BANNER_IMAGE}`}
                        sizes="150px"
                        width={this.width}
                        height={this.height}
                        src={this.isViewed ? this.logo : undefined}
                        alt="promotion logo"
                    />
                </picture>
            </Host>
        );
    }
}
